import React from 'react'

function XCircle() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14Z"
        stroke="#FF3830"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6L6.5 10"
        stroke="#FF3830"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10L6.5 6"
        stroke="#FF3830"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default XCircle
